// import { Button, Paper } from "@mui/material";
// import CustomText from "components/typography/CustomText";
import { Grid } from "@mui/material";
import { ERR_NETWORK } from "constants/messages";
import { modifyArray } from "lib/arrayObject";
import { serverGet, serverPost } from "lib/serverRequest";
import { useSnackbar } from "notistack";
import CustomerInfo from "pages/subscriptions/details/CustomerInfo";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import BoxPiesList from "./BoxPiesList";
import OrderSummaryInfo from "./OrderSummaryInfo";
// import PaymentMethods from "./PaymentMethods";

export default function OrderDetailComponent() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState({});
  const { slotId = "" } = useParams();
  const authUser = useSelector((state) => state?.auth?.user ?? {});
  const orderInfo = useSelector((state) => state?.app?.orderInfo ?? {});

  const handleChangePie = (newValue, index) => {
    const pies = data?.pies ?? [];
    const newPies = modifyArray(pies, index, newValue);
    //checking the changed pies.
    let changePies = newPies?.reduce(
      (ret, cur, index) =>
        cur?.id !== pies?.[index]?.id ? [...ret, cur] : ret,
      []
    );
    serverPost({
      url: "box/update",
      data: {
        pies: newPies,
        id: data?.box_id,
        weekly_slot_id: data?.id,
        log_data:
          changePies?.length > 0
            ? {
                user_id: data?.user_id ?? "",
                changer_id: authUser?.id,
                changer_type: "admin",
                box_id: data?.box_id,
                weekly_slot_id: data?.id ?? "",
                log: `${authUser?.name} ( admin ) - Order #${data?.id} - Flavour Update - Removed ${pies?.[index]?.name}, Added ${newPies?.[index]?.name}`,
                // log: `${authUser?.name} ( admin ) updates the flavours of order #${data?.id}`,
              }
            : {},
      },
      onFinish: (res, err) => {
        if (res === false) return;
        setData((s = {}) => ({ ...s, pies: newPies }));
        enqueueSnackbar("Successfully Updated Flavour", {
          variant: "success",
        });
      },
    });
  };

  const loadDetailsData = (slotId) => {
    serverGet({
      url: `weeklySlots/${slotId}`,
      onFinish: (res, err) => {
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        } else {
          if ( res.box_type === true ) {
            enqueueSnackbar("This one off order does not exist.", { variant: "warning" });
            return;
          } else {
            setData(res);
            dispatch({ type: "SET_APP", payload: { orderInfo: res } });
          }
        }
      },
    });
  };

  const handleUpdate = (res, err) => {
    if (res === false) {
      if (!res && err?.message) {
        enqueueSnackbar(err?.message, { variant: "warning" });
      } else {
        enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
      }
      return;
    }
    // enqueueSnackbar("Successfully Updated in.", { variant: "success" });
    dispatch({
      type: "SET_APP",
      payload: { orderInfo: { ...data, ...(res?.[0] ?? {}) } },
    });
    setData((s = {}) => ({ ...s, ...(res?.[0] ?? {}) }));
  };

  const handleChangeNote = (e) => {
    setData((s = {}) => ({ ...s, [e.target.name]: e.target.value }));
  };

  const handleChangeCompanyName = (e) => {
    setData((s = {}) => ({
      ...s,
      // other: { ...s.other, company_name: e.target.value },
      [e.target.name]: e.target.value,
    }));
  };

  const handleChangeRecipientName = (e) => {
    setData((s = {}) => ({
      ...s,
      // other: { ...s.other, company_name: e.target.value },
      [e.target.name]: e.target.value,
    }));
  };

  const handleBlurNote = (res, err) => {
    if (res === false) {
      if (!res && err?.message) {
        enqueueSnackbar(err?.message, { variant: "warning" });
      } else {
        enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
      }
      return;
    }
    enqueueSnackbar("Successfully Updated Delivery Note", {
      variant: "success",
    });
    dispatch({
      type: "SET_APP",
      payload: { orderInfo: { ...data, ...(res?.[0] ?? {}) } },
    });
    setData((s = {}) => ({ ...s, ...(res?.[0] ?? {}) }));
  };

  const handleEditUser = (res) => {
    setData((s = {}) => ({
      ...s,
      name: res.name,
      phone: res.phone,
      user_status: res.status,
    }));
  };

  const handleBlurCompanyName = () => {
    const newCompanyName = data?.company_name ?? "";
    const prevCompanyName = orderInfo?.company_name ?? "";
    serverPost({
      url: "box/update",
      data: {
        id: data?.box_id,
        weekly_slot_id: data?.id,
        other: data?.other,
        pies: data?.pies ?? [],
        box_type: "one_off",
        log_data: Boolean(newCompanyName !== prevCompanyName)
          ? {
              user_id: data?.user_id ?? "",
              changer_id: authUser?.id,
              changer_type: "admin",
              box_id: data?.box_id,
              weekly_slot_id: data?.id ?? "",
              log: `${authUser?.name} ( admin ) - Order #${data?.id} - Update Company Name - ${newCompanyName}`,
            }
          : {},
      },
      onFinish: (res, err) => {
        // onBlur(res, err);
        enqueueSnackbar("Successfully Updated Company Name", {
          variant: "success",
        });
      },
    });
  };

  const handleBlurRecipientName = () => {
    const newRecipientName = data?.box_name ?? "";
    const prevRecipientName = orderInfo?.box_name ?? "";
    serverPost({
      url: "box/update",
      data: {
        id: data?.box_id,
        weekly_slot_id: data?.id,
        other: {
          box_name: data?.box_name ?? "",
          company_name: data?.company_name ?? "",
          delivery_note: data?.delivery_note ?? "",
        },
        pies: data?.pies ?? [],
        box_type: "one_off",
        log_data: Boolean(newRecipientName !== prevRecipientName)
          ? {
              user_id: data?.user_id ?? "",
              changer_id: authUser?.id,
              changer_type: "admin",
              box_id: data?.box_id,
              weekly_slot_id: data?.id ?? "",
              log: `${authUser?.name} ( admin ) - Order #${data?.id} - Update Recipient Name - ${newRecipientName}`,
            }
          : {},
      },
      onFinish: (res, err) => {
        // onBlur(res, err);
        enqueueSnackbar("Successfully Updated Recipient Name", {
          variant: "success",
        });
      },
    });
  };

  useEffect(() => {
    loadDetailsData(slotId);
    //eslint-disable-next-line
  }, [slotId]);

  const slotMove = (id) => {
    loadDetailsData(id);
  };
  return (
    <div>
      <OrderSummaryInfo
        data={data}
        onUpdate={handleUpdate}
        slotMove={slotMove}
      />
      <div className="my-4">
        <Grid container spacing={2}>
          <Grid className="flex" item lg={4} md={4} sm={12} xs={12}>
            <CustomerInfo
              data={data}
              onEditUser={handleEditUser}
              onChangePhoneCode={(v) =>
                setData((prev) => ({ ...prev, phone_code: v }))
              }
            />
          </Grid>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <BoxPiesList
              pies={data?.pies?.slice(0, 8) ?? []}
              data={data}
              onChange={handleChangePie}
              onChangeNote={handleChangeNote}
              onChangeCompanyName={handleChangeCompanyName}
              onBlurCompanyName={handleBlurCompanyName}
              onChangeRecipientName={handleChangeRecipientName}
              onBlurRecipientName={handleBlurRecipientName}
              onBlur={handleBlurNote}
            />
          </Grid>
        </Grid>
      </div>
      {/* <HistoryTimeline /> */}
    </div>
  );
}
